/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { SkillOverridesControllerFindAllQueryResponse, SkillOverridesControllerFindAll401, SkillOverridesControllerFindAll403 } from "../../models/skillOverridesController/SkillOverridesControllerFindAll";

function getSkillOverridesControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/skill-overrides` as const }  
  return res
}

/**
 * @summary List visible skill overrides
 * {@link /api/v1/skill-overrides}
 */
export async function skillOverridesControllerFindAll(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<SkillOverridesControllerFindAllQueryResponse, ResponseErrorConfig<SkillOverridesControllerFindAll401 | SkillOverridesControllerFindAll403>, unknown>({ method : "GET", url : getSkillOverridesControllerFindAllUrl().url.toString(), ... requestConfig })  
  return res.data
}